import { FunctionComponent } from 'react';
import _ from 'lodash';

import { ACTION_OPEN_ACHIEVEMENTS, CATEGORY_PROFILE } from 'utils/analytics/eventTypesConstants';
import { StoreType } from '@tock/shared/utils/connect';
import {
  allAchievementsSelector,
  patronAchievementsSelector,
} from 'selectors/achievementsSelectors';
import { consumer, core } from '@tock/coretypes';
import { useSelector } from 'react-redux';
import AchievementButton from 'components/profile/achievements/AchievementButton';
import OverflowButton from 'components/profile/achievements/OverflowButton';

const MAX_ACHIEVEMENTS = 5;

interface Props {
  setAchievementsModalIsOpen(isOpen: boolean): void;
}

const AchievementsBar: FunctionComponent<Props> = ({ setAchievementsModalIsOpen }) => {
  const { achievements, allAchievements } = useSelector((state: StoreType) => ({
    achievements: patronAchievementsSelector(state),
    allAchievements: allAchievementsSelector(state),
  }));
  return (
    <AchievementsBarInternal
      setAchievementsModalIsOpen={setAchievementsModalIsOpen}
      allAchievements={allAchievements}
      earnedAchievements={achievements}
    />
  );
};

interface AchievementsBarInternalProps {
  earnedAchievements: core.IPatronProfileAchievement[];
  allAchievements: consumer.AchievementDescription[];
  setAchievementsModalIsOpen(isOpen: boolean): void;
}

const AchievementsBarInternal: FunctionComponent<AchievementsBarInternalProps> = ({
  earnedAchievements,
  allAchievements,
  setAchievementsModalIsOpen,
}) => {
  const onClickOpenModal = (achievementName?: String) => {
    window.analytics.sendEvent(CATEGORY_PROFILE, ACTION_OPEN_ACHIEVEMENTS, achievementName);
    setAchievementsModalIsOpen(true);
  };
  const achievementsToShow = _.take(earnedAchievements, MAX_ACHIEVEMENTS);

  const nameToPatronAchievement = _.keyBy(earnedAchievements, 'name');

  const availableAchievements = allAchievements.filter(
    (achievement) => !!achievement && !nameToPatronAchievement[achievement.name]
  );
  const availableAchievementsToShow = _.take(
    availableAchievements,
    MAX_ACHIEVEMENTS - earnedAchievements.length
  );

  return (
    <div className="AchievementsBar_container">
      {achievementsToShow.map((achievement) => {
        if (!achievement.name || !achievement.level) {
          return null;
        }
        return (
          <AchievementButton
            name={achievement.name}
            level={achievement.level}
            key={achievement.name || undefined}
            isAchieved={true}
            onClick={() => onClickOpenModal(achievement.name || undefined)}
          />
        );
      })}
      {availableAchievementsToShow.map((achievement) => {
        if (!achievement.name || !achievement.level) {
          return null;
        }
        return (
          <AchievementButton
            name={achievement.name}
            key={achievement.name || undefined}
            isAchieved={false}
            onClick={() => onClickOpenModal(achievement.name)}
          />
        );
      })}
      <OverflowButton
        onClick={onClickOpenModal}
        nOverflowElements={Math.max(earnedAchievements.length - MAX_ACHIEVEMENTS, 0)}
      />
    </div>
  );
};

export default AchievementsBar;
